import {
	SET_TRANSACTION_CATEGORIES,
	SET_TRANSACTION_CATEGORY,
	CLEAR_TRANSACTION_CATEGORIES,
	CLEAR_TRANSACTION_CATEGORY,
	ADD_TRANSACTION_CATEGORY,
	UPDATE_TRANSACTION_CATEGORY,
	REMOVE_TRANSACTION_CATEGORY,
} from './actionTypes';

export const transactionCategory = (state = {}, action) => {
	switch (action.type) {
		case SET_TRANSACTION_CATEGORY:
			return action.payload;
		case UPDATE_TRANSACTION_CATEGORY:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_TRANSACTION_CATEGORY:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_TRANSACTION_CATEGORIES:
			return action.payload;
		case ADD_TRANSACTION_CATEGORY:
			return [...state, action.payload];
		case UPDATE_TRANSACTION_CATEGORY:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_TRANSACTION_CATEGORY:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_TRANSACTION_CATEGORIES:
			return [];
		default:
			return state;
	}
};
